
import { CustomAvatarGroup } from "@/components/custom/CustomAvatarGroup";
import { User } from "@/hooks/use-event-guests";
interface GuestSectionProps {
  hostUser: User | null;
  acceptedGuests: User[];
  invitedGuests: User[];
  isLoading?: boolean;
}
export const GuestSection = ({
  hostUser,
  acceptedGuests,
  invitedGuests,
  isLoading = false
}: GuestSectionProps) => {
  // If we're still loading invites, show loading skeletons
  if (isLoading) {
    return <div className="p-4 flex flex-col space-y-4">
        {/* Organizer section skeleton */}
        <div className="space-y-1 relative">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Organizer</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
        
        {/* Going section skeleton */}
        <div className="space-y-1 relative">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Going</span>
          </div>
          <div className="relative" style={{
          height: "32px"
        }}>
            <CustomAvatarGroup users={[]} maxVisible={3} size="sm" />
          </div>
        </div>
      </div>;
  }

  return <div className="p-4 flex flex-col space-y-4">
      {/* Host section */}
      {hostUser && <div className="space-y-1 relative">
          <div className="flex items-center justify-between">
            <span className="text-xs font-thin">Host</span>
          </div>
          <div className="flex items-center space-x-2">
            <CustomAvatarGroup users={[hostUser]} maxVisible={1} size="sm" />
            <span className="font-thin text-sm">
              {hostUser.full_name}
            </span>
          </div>
        </div>}
      
      {/* Going section */}
      <div className="space-y-1 relative">
        <div className="flex items-center justify-between">
          <span className="text-xs font-thin">Guests</span>
        </div>
        <div className="relative" style={{
        height: "32px"
      }}>
          <CustomAvatarGroup users={acceptedGuests} maxVisible={3} size="sm" />
        </div>
      </div>
    </div>;
};
